import React, { Component } from "react";
import FormSection from "@my-dld/components/Form/FormSection";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { EjariTenantType, Lookup } from "@eres/ejari-api/Entity";
import { hideLoading, LoadableDataState, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import {
	AlphaSortProcessor,
	isGovernmentAuthority,
	isLicStateAuthority,
	LicenseAuthoritiesEmiratesTransformer,
	LicSourceProcessor,
	populateLookupOnTo,
	StateConsumer
} from "@eres/ejari-api/Utils";
import { EjariLookUp } from "@eres/ejari-api/constants";
import { IdExtractor } from "@my-dld/utils/LookupUtil";
import FormAction from "@my-dld/components/Form/FormAction";
import { DateUtil, LocaleUtil, StringUtil } from "@eres/core";
import _ from "lodash";
import { CompanyTenantSearch, PersonTenantSearchRequest, VerifyOTP } from "@eres/ejari-api/IApi";
import { EjariApi } from "@eres/ejari-api";
import { ContractValidationError, Tenant } from "@eres/ejari-api/Entity/tenant";
import { JQModal } from "@my-dld/components/Popup/Utils";
import Popup from "@my-dld/components/Popup/Popup";
import { navigate } from "@my-dld/utils/StoreUtils";
import { updateContractContext } from "@eres/ejari-core/contexts/EjariContractContext";
import StateHolder from "@eres/forms/StateHolder";
import { WebFormFieldProps } from "@eres/forms-web";
import FormRow from "@eres/forms-web/FormRow";
import TextInputField from "@eres/forms-web/TextInputField";
import PickerInput from "@eres/forms-web/PickerInput";
import RadioInputField from "@eres/forms-web/RadioInputField";
import EidInputField from "@eres/forms-web/EidInputField";
import eidConverter from "@eres/forms/converters/EidConverter";
import FormMandatory from "../FormMandatory";
import DateInputField from "@eres/forms-web/DateInputField";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import VerifyAccess from "@eres/dldvault/screens/VerifyAccess";
import VerifyEmailOtp from "./VerifyEmailOtp";
import { getEmail, getUser } from "@10x/sso";
import { toast } from "react-toastify";

interface Props extends RoutedViewProps {
}

interface LookupState {
	TenantTypes?: Lookup[];
	PersonTypes?: Lookup[];
	Emirates?: Lookup[];
	Authorities?: Lookup[];
	Countries?: Lookup[];
	LicenseStates?: Lookup[];
}

interface FormState {
	TenantType?: Lookup;
	PersonType?: Lookup;
	Emirate?: Lookup;
	Authority?: Lookup;
	Country?: Lookup;
	LicenseState?: Lookup;
	eid?: string;
	passport?: string;
	licenseNumber?: string;
	companyName?: string;
	dob?: string;
	verifyOTP?: boolean;
	tenant?: Tenant;
}

interface State extends LookupState, FormState, LoadableDataState {
	showState: boolean;
	showCompanyName: boolean;
	tenant?: Tenant;
}


class SearchTenant extends Component<Props, State> {
	today = new Date();
	constructor( props: Props ) {
		super( props );
		this.state = {
			PersonTypes: PersonSearchTypes,
			loadState: "loading",
			errorContainer: {},
			showState: false,
			showCompanyName: false,
			eid: "",
			verifyOTP: false,
			tenant: undefined,
		};
		this.today = new Date();
	}

	componentDidMount() {
		populateLookupOnTo( EjariLookUp.TENANT_TYPES, StateConsumer( this, "TenantTypes" ) );
	}

	isValid = () => {
		let isValid = true;
		const {
			TenantType, PersonType, eid, passport, Country, Emirate, Authority, licenseNumber,
			LicenseState, companyName, showCompanyName, showState, dob
		} = this.state;
		isValid = isValid && TenantType != null;
		if ( isValid && TenantType?.Id === EjariTenantType.PERSON ) {
			isValid = isValid && PersonType != null;
			if ( isValid && PersonType?.Id === EMIRATES_IDENTITY.Id ) {
				isValid = isValid && !StringUtil.isEmptyStringOrNull( eid ) && eid?.length === 15;
			} else if ( isValid && PersonType?.Id === PASSPORT_IDENTITY.Id ) {
				isValid = isValid && !StringUtil.isEmptyStringOrNull( passport );
				isValid = isValid && Country != null;
			}
			isValid = isValid && !StringUtil.isEmptyStringOrNull( dob );
		} else if ( isValid && TenantType?.Id === EjariTenantType.COMPANY ) {
			isValid = isValid && Emirate != null;
			isValid = isValid && Authority != null;
			if ( isValid ) {
				if ( showCompanyName )
					isValid = isValid && !StringUtil.isEmptyStringOrNull( companyName );
				else
					isValid = isValid && !StringUtil.isEmptyStringOrNull( licenseNumber );
				if ( showState )
					isValid = isValid && LicenseState != null;
			}
		}
		return isValid;
	};
	updateLicenseAuthorities = () => {
		const { Emirate } = this.state;
		if ( Emirate ) {
			this.setState( {
				Authorities: Emirate.Children,
				Authority: undefined,
			} );
		}
	};

	updateFields = () => {
		const { Authority } = this.state;
		if ( Authority ) {
			this.setState( {
				showState: isLicStateAuthority( Authority ),
				showCompanyName: isGovernmentAuthority( Authority ),
			} );
		} else {
			this.setState( {
				showState: false,
				showCompanyName: false,
			} );
		}
	};

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		if ( prevState.PersonType !== PASSPORT_IDENTITY && this.state.PersonType === PASSPORT_IDENTITY
			&& this.state.Countries === undefined ) {
			populateLookupOnTo( EjariLookUp.COUNTRY, StateConsumer( this, "Countries" ), undefined, AlphaSortProcessor );
		}
		if ( prevState.TenantType?.Id !== EjariTenantType.COMPANY && this.state.TenantType?.Id === EjariTenantType.COMPANY
			&& this.state.Emirate == null
		) {
			populateLookupOnTo( EjariLookUp.EMIRATES, StateConsumer( this, "Emirates" ), LicenseAuthoritiesEmiratesTransformer, LicSourceProcessor );
			// populateLookupOnTo(EjariLookUp.LICENSE_ISSUERS, StateConsumer(this, "AllAuthorities"), undefined, AlphaSortProcessor);
			populateLookupOnTo( EjariLookUp.LICENSE_STATES, StateConsumer( this, "LicenseStates" ), undefined, AlphaSortProcessor );
		}

		if ( this.state.Emirates !== prevState.Emirates || ( this.state.Emirate && this.state.Emirate?.Id !== prevState.Emirate?.Id ) ) {
			this.updateLicenseAuthorities();
		}
		if ( !_.isEqual( this.state.Authority, prevState.Authority ) ) {
			this.updateFields();
		}
	}

	render() {
		const {
			errorContainer,
			TenantTypes, TenantType,
			PersonTypes, PersonType,
			Countries, Country,
			Emirates, Emirate,
			Authorities, Authority,
			showState, showCompanyName,
			LicenseStates, LicenseState,
		} = this.state;
		const isValid = this.isValid();
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group",
		};
		return ( <>
				<FormSection title={ Strings.tenant_information }>
					<FormMandatory/>
					<FormRow { ...filedProps }>
						<RadioInputField
							required={ true }
							isLoading={ TenantTypes === undefined }
							id={ "TenantType" }
							toIdentifier={ IdExtractor }
							label={ Strings.tenant_type } items={ TenantTypes }
						/>
					</FormRow>
					{ TenantType &&
						<>
							{ TenantType.Id === EjariTenantType.PERSON &&
								<>
									<FormRow { ...filedProps }>
										<RadioInputField
											required={ true }
											isLoading={ PersonTypes === undefined }
											id={ "PersonType" }
											toIdentifier={ IdExtractor }
											label={ Strings.identity_type } items={ PersonTypes }
										/>
									</FormRow>
									{ PersonType && <>
										{ PersonType.Id === EMIRATES_IDENTITY.Id && <>
											<FormRow { ...filedProps }>
												<EidInputField
													id={ "eid" }
													label={ Strings.emirates_id_number }
													error={ errorContainer.eid }
													placeHolder={ "784-XXXX-XXXXXX-X" }
													valueConverter={ eidConverter }
												/>
											</FormRow>
										</> }
										{ PersonType.Id === PASSPORT_IDENTITY.Id && <>
											<FormRow { ...filedProps }>
												<TextInputField
													required={ true }
													error={ errorContainer.passport }
													id={ "passport" }
													label={ Strings.passport_number }
													maxLength={ 20 }
												/>
												<PickerInput
													required={ true }
													isLoading={ Countries === undefined }
													id={ "Country" }
													toIdentifier={ IdExtractor }
													label={ Strings.country }
													items={ Countries }
												/>
											</FormRow>
										</> }
										<FormRow { ...filedProps }>
											<DateInputField
												required={ true }
												id={ "dob" }
												label={ Strings.date_of_birth }
												extraOpts={ {
													maxDate: this.today,
													yearRange: "-100:+0"
												} }
											/>
										</FormRow>
									</> }
								</> }
							{ TenantType.Id === EjariTenantType.COMPANY &&
								<>
									<FormRow { ...filedProps }>
										<PickerInput
											required={ true }
											isLoading={ Emirates === undefined }
											id={ "Emirate" }
											toIdentifier={ IdExtractor }
											label={ Strings.lic_issuer_emirate }
											items={ Emirates }
										/>
										{ Emirate &&
											<PickerInput
												required={ true }
												isLoading={ Authorities === undefined }
												id={ "Authority" }
												toIdentifier={ IdExtractor }
												label={ Strings.lic_issuer_authority }
												items={ Authorities }
											/>
										}
										{ Authority && !showCompanyName &&
											<TextInputField
												required={ true }
												error={ errorContainer.licenseNumber }
												id={ "licenseNumber" }
												label={ Strings.lic_number }
												maxLength={ 20 }
											/>
										}
										{ Authority && showCompanyName &&
											<TextInputField
												required={ true }
												error={ errorContainer.companyName }
												id={ "companyName" }
												label={ Strings.company_name }
												maxLength={ 80 }
											/>
										}
										{ Authority && showState &&
											<PickerInput
												required={ true }
												isLoading={ LicenseStates === undefined }
												id={ "LicenseState" }
												toIdentifier={ IdExtractor }
												label={ Strings.license_state }
												items={ LicenseStates }
											/>
										}
									</FormRow>
								</> }
						</>
					}
					{this.state.verifyOTP && <VerifyEmailOtp
						email={getEmail()}
						onResend={this.onSearch}
						onCancel={ () => {
							this.setState({verifyOTP: false});
						} }
						onConfirmed={ (otp: string) => {
							this.onVerifyOTP(otp);
						} }/>}

					<Popup id={ "new_tenant" }>
						{ Strings.tenant_new_desc }
						<FormAction
							groupClassName={ "text-center" }
							primaryActionLabel={ Strings.new_tenant }
							onPrimaryAction={ this.onAddNewTenant }
							secondaryActionLabel={ Strings.cancel }
							onSecondaryAction={ this.onCancelAddNewTenant }
						/>
					</Popup>
				</FormSection>
				<FormRow>
					<FormAction
						groupClassName="text-center"
						disablePrimaryAction={ !isValid }
						primaryActionLabel={ Strings.search }
						secondaryActionLabel={ Strings.back }
						onSecondaryAction={ this.onBack }
						onPrimaryAction={ this.onSearch }/>
				</FormRow>
			</>
		);
	}

	onBack = () => {
		this.props.history.go( -2 );
	};
	buildNewTenant = () => {
		let t = {} as Tenant;
		if ( this.state.tenant !== null ) {
			t = { ...this.state.tenant };
		}
		const {
			TenantType, Emirate, Authority, showCompanyName, PersonType,
			LicenseState, licenseNumber, showState, eid, passport, Country
		} = this.state;
		if ( TenantType?.Id === EjariTenantType.PERSON ) {
			t.Person = this.state?.tenant?.Person ? { ...this.state.tenant.Person } : {};
			t.IsCompany = false;
			t.Company = undefined;
			if ( PersonType?.Id === EMIRATES_IDENTITY.Id ) {
				t.Person.EmiratesId = eid;
			} else {
				t.Person.PassportNo = passport;
				t.Person.NationalityId = Country?.Id;
			}
		} else {
			t.Person = undefined;
			t.IsCompany = true;
			t.Company = {
				LicenseIssuerEmirate: Emirate?.Id,
				LicenseIssuer: Authority?.Id + "",
			};
			if ( !showCompanyName ) {
				t.Company.LicenseNo = licenseNumber;
			}
			if ( showState ) {
				t.Company.LicenseStateId = LicenseState?.Id;
			}
		}
		return t;
	};
	onCancelAddNewTenant = () => {
		JQModal( "new_tenant" ).hide();
	};
	onAddNewTenant = () => {
		JQModal( "new_tenant" ).hide( () => {
			updateContractContext( {
				tenant: undefined,
				OrgTenant: this.buildNewTenant(),
			} );
			navigate( "info" );
		} );

	};
	onSearch = () => {
		const {
			TenantType, PersonType, Emirate, Authority, Country,
			LicenseState, eid, passport, licenseNumber, companyName, showState, showCompanyName, dob
		} = this.state;
		if ( TenantType?.Id === EjariTenantType.PERSON ) {
			const dobS = DateUtil.formatDate( dob?.asDate()!, "YYYY-MM-DD", "en" );
			const req: PersonTenantSearchRequest = { DOB: dobS };
			if ( PersonType?.Id === EMIRATES_IDENTITY.Id ) {
				req.EmiratesId = eid;
			} else {
				req.NationalityCountryId = Country?.Id + "";
				req.PassportNo = passport;
			}
			showLoading();
			EjariApi.searchPersonTenant( req )
			.then( value => {
				hideLoading();
				 this.handleTenantResponse( value );
			} )
			.catch( e => {
				hideLoading();
				if ( e?.ErrorEnum === "DOBNotMatched" ) {
					const dx = e as ContractValidationError;
					const msg = getLocalValue( { en: dx.ErrorDescEn, ar: dx.ErrorDescAr } );
					showErrorMessage( msg );
					return;
				}
				this.handleTenantResponse( undefined );
			} );
		} else if ( TenantType?.Id === EjariTenantType.COMPANY ) {
			const req: CompanyTenantSearch = {};
			req.Issuer = Authority?.Id + "";
			if ( !showCompanyName ) {
				req.TradeLicenseNo = licenseNumber;
			} else {
				req.companyName = companyName;
			}
			if ( showState ) {
				req.LicenseStateId = LicenseState?.Id + "";
			}
			showLoading();
			// Update API to search company SOHRAB
			EjariApi.getTenantCompany( req )
			.then( value => {
				hideLoading();
				if (value.ResponseHash) {
					this.setState({verifyOTP: true, tenant: value});
				}
			} )
			.catch( e => {
				hideLoading();
				if ( e?.ErrorEnum === "NoRecordFound" ) {
					const dx = e as ContractValidationError;
					const msg = getLocalValue( { en: dx.ErrorDescEn, ar: dx.ErrorDescAr } );
					showErrorMessage( msg );
					return;
				}
				this.handleTenantResponse( undefined );
			} );
		}
	};

	onVerifyOTP = (otp: string) => {
		const req: VerifyOTP = {
			otpToken: otp,
			responseHash: this.state.tenant?.ResponseHash
		};
		showLoading();
		EjariApi.verifyOTP( req )
		.then( value => {
			if (value.TenantId) {
				this.setState({tenant: value});
				setTimeout(() => {
					this.handleTenantResponse( this.state.tenant );
				}, 200);
				JQModal( "otp_verify_pop" ).hide();
			} else {
				this.handleTenantResponse( undefined );
			}
			hideLoading();
		} )
		.catch( e => {
			hideLoading();
			if (e?.Error === "UnableToValidateToken" ) {
				const dx = e as ContractValidationError;
				const msg = getLocalValue( { en: dx.ErrorDescEn, ar: dx.ErrorDescAr } );
				showErrorMessage( msg );
				return;
			}
			toast.dark( Strings.invalid_otp );
		} );
	}

	handleTenantResponse = ( tenant?: Tenant ) => {
		const isValidTenant = tenant?.TenantId;
		tenant = this.updateTenantInfo( tenant );
		this.setState( { tenant: tenant } );
		if ( isValidTenant ) {
			updateContractContext( {
				tenant: undefined,
				OrgTenant: tenant,
			} );
			navigate( "info" );
		} else {
			JQModal( "new_tenant" ).show();
		}
	};
	updateTenantInfo = ( tenant?: Tenant ): Tenant => {
		if ( tenant == null ) tenant = {};
		else tenant = { ...tenant };
		tenant.ValidationErrors = undefined;
		const {
			TenantType, PersonType, Emirate, Authority, Country,
			LicenseState, eid, passport, licenseNumber, companyName, showState, showCompanyName
		} = this.state;
		if ( TenantType?.Id === EjariTenantType.PERSON ) {
			if ( tenant.Person == null ) tenant.Person = {};
			tenant.IsCompany = false;
			if ( PersonType?.Id === EMIRATES_IDENTITY.Id ) {
				tenant.Person.EmiratesId = eid;
			} else {
				tenant.Person.NationalityId = Country?.Id;
				tenant.Person.PassportNo = passport;
			}
		} else if ( TenantType?.Id === EjariTenantType.COMPANY ) {
			if ( tenant.Company == null ) tenant.Company = {};
			tenant.IsCompany = true;
			if ( !showCompanyName ) {
				tenant.Company.LicenseNo = licenseNumber;
			} else {
				tenant.Company.GovernmentComanyNameEn = companyName;
			}
			if ( showState ) {
				tenant.Company.LicenseState = LicenseState?.Id + "";
			}
		}
		return tenant;
	};

}

export const EMIRATES_IDENTITY: Lookup = {
	Id: 1,
	...LVStrings.emirates_id,
};
export const PASSPORT_IDENTITY = {
	Id: 2,
	...LVStrings.passport,
};
const PersonSearchTypes = [ EMIRATES_IDENTITY, PASSPORT_IDENTITY ];
export default SearchTenant;
